import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Card,
  CardBody,
} from 'reactstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import property_img from '../../images/properties_img.png';
import language_img from '../../images/language.png';
import appearance_img from '../../images/web_appear.png';
import external_link_img from '../../images/external_links.png'
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import HelpCenterChatBot from './HelpCenterChatBot';
import HelpCenterServiceAddons from './HelpCenterServiceAddons';
import HelpCenterCustomFonts from './HelpCenterCustomFonts';
import HelpCenterLocation from './HelpCenterLocation';
import HelpCenterExternalLink from './HelpCenterExternalLink';
import HelpCenterDigitalAssistant from './HelpCenterDigitalAssistant';
import HelpCenterIntegrationInfo from './HelpCenterIntegrationInfo';
import HelpCenterCodeSnippet from './HelpCenterCodeSnippet';
import NudgesSetting from './NudgesSetting';
import UrlNudgesSetting from './UrlNudgesSetting';
import MultliLanguages from '../MultliLanguages';
import BubblePosition from '../BubblePosition';
import MessengerRestricted from './MessengerRestricted';
import CustomCss from './CustomCss';
import Example from '../Example';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  API_HelpCenter_Integration,
  gAPI_Ingetration,
  gAPI_Internal_Property_By_Id,
  gAPI_Property_List_By_Group,
  dAPI_Delete_Ingetration,
} from '../../../../../../constants/APIs';
import { NavLink } from 'react-router-dom';
import { faHandSpock } from '@fortawesome/free-regular-svg-icons';
import {
  faPalette,
  faLanguage,
  faComment, faCalendar, faCalendarAlt,
  faLocationArrow, faFont, faExternalLinkAlt, faRobot, faFileCode,
} from '@fortawesome/free-solid-svg-icons';
import { faWpforms } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import digital_guide_book from '../../images/digital_guide_book.png';
import digital_guide_book_language from '../../images/digital_guide_book_language.png';
import Validation from '../../../../../../components/Validation';
import CalendarIntegration from './CalendarIntegration';
import ErrorPopup from '../ErrorPopup';
import { fetchServiceRequest } from '../../../../../../redux/service/actions';

function HelpCenterIntegrationList({ match, history, propertyId, locale, serviceProvider, featuresUrl, fetchServiceRequest }) {
  const integrationId = match.params.id;
  const [integration, setIntegration] = useState();
  const [allProperties, setAllProperties] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [propertyVisible, setPropertyVisible] = useState(true);
  const [apperanceVisible, setApperanceVisible] = useState(false);
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [nudgesVisible, setNudgesVisible] = useState(false);
  const [urlnudgesVisible, setUrlNudgesVisible] = useState(false);
  const [positionVisible, setPositionVisible] = useState(false);
  const [languageVisible, setLanguageVisible] = useState(false);
  const [publishVisible, setPublishVisible] = useState(false);
  const [serviceAddonVisible, setServiceAddonVisible] = useState(false);
  const [locationVisible, setLocationVisible] = useState(false);
  const [externalLinkVisible, setExternalLinkVisible] = useState(false);
  const [fontsVisible, setFontsVisible] = useState(false);
  const [botVisible, setBotVisible] = useState(false);
  const [restrictedVisible, setRestrictedVisible] = useState(false);
  const [cssVisible, setCssVisible] = useState(false);
  const [propertyData, setPropertyData] = useState([]);
  const [isPageError, setIsPageError] = useState(false);
  const localeOptions = [
    { id: "en", name: "English", desc: "English", code: "en", locale: "en" },
    { id: "hi", name: "Hindi", desc: "हिंदी", code: "hi", locale: "hi" },
    {
      id: "id",
      name: "Indonesian",
      desc: "bahasa Indonesia",
      code: "id",
      locale: "id",
    },
    { id: "it", name: "Italian", desc: "Italiano", code: "it", locale: "it" },
    { id: "es", name: "Spanish", desc: "Español", code: "es", locale: "es" },
    { id: "fr", name: "French", desc: "français", code: "fr", locale: "fr" },
    { id: "de", name: "German", desc: "Deutsche", code: "de", locale: "de" },
    { id: "zh", name: "Chinese", desc: "简体中文", code: "ZH-簡", locale: "zh" },
    {
      id: "vi",
      name: "Vietnamese",
      desc: "Tiếng Việt",
      code: "vi",
      locale: "vi",
    },
    { id: "th", name: "Thai", desc: "ไทย", code: "th", locale: "th" },
    { id: "ja", name: "Japanese", desc: "日本語", code: "ja", locale: "ja" },
    {
      id: "zh-TW",
      name: "Chinese (Traditional)",
      desc: "繁體中文",
      code: "ZH-繁",
      locale: "hk",
    },
    {
      id: "tl",
      name: "Tagalog (Filipino)",
      desc: "Tagalog (Filipino)",
      code: "tl",
      locale: "tl",
    },
    { id: "af", name: "Afrikaans", desc: "Afrikaans", code: "af", locale: "af" },
    { id: "ko", name: "Korean", desc: "한국어", code: "ko", locale: "ko" },
    { id: "mi", name: "Maori", desc: "Maori", code: "mi", locale: "mi" },
    { id: 'ar', name: 'Arabic', desc: "عربي", code: "ar", locale: "ar" },
    { id: "pt", name: "Portuguese", desc: "Português", code: "pt", locale: "pt" },
    { id: 'ru', name: 'Russian', desc: "Русский", code: "ru", locale: "ru" },
    { id: 'km', name: 'Cambodian', desc: "ខ្មែរ", code: "km", locale: "km" },
  ];

  const preview_demo = (
    featuresUrl !== null && featuresUrl !== undefined && !featuresUrl.includes("myma.ai")
  )
    ? `https://preview.${featuresUrl}/messenger-preview`
    : process.env.REACT_APP_MESSENGER_DEMO;

  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const property = () => {
    setPropertyVisible(true);
    setApperanceVisible(false);
    setCalendarVisible(false);
    setNudgesVisible(false);
    setUrlNudgesVisible(false);
    setPositionVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
    setExternalLinkVisible(false);
    setLocationVisible(false);
    setServiceAddonVisible(false);
    setFontsVisible(false);
    setBotVisible(false);
    setRestrictedVisible(false);
    setCssVisible(false);
  };
  const appearance = () => {
    setPropertyVisible(false);
    setApperanceVisible(true);
    setCalendarVisible(false);
    setNudgesVisible(false);
    setUrlNudgesVisible(false);
    setPositionVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
    setExternalLinkVisible(false);
    setLocationVisible(false);
    setServiceAddonVisible(false);
    setFontsVisible(false);
    setBotVisible(false);
    setRestrictedVisible(false);
    setCssVisible(false);
  };
  const calendar = () => {
    setPropertyVisible(false);
    setApperanceVisible(false);
    setCalendarVisible(true);
    setNudgesVisible(false);
    setUrlNudgesVisible(false);
    setPositionVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
    setExternalLinkVisible(false);
    setLocationVisible(false);
    setServiceAddonVisible(false);
    setFontsVisible(false);
    setBotVisible(false);
    setRestrictedVisible(false);
    setCssVisible(false);
  };
  const nudges = () => {
    setPropertyVisible(false);
    setApperanceVisible(false);
    setCalendarVisible(false);
    setNudgesVisible(true);
    setUrlNudgesVisible(true);
    setPositionVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
    setExternalLinkVisible(false);
    setLocationVisible(false);
    setServiceAddonVisible(false);
    setFontsVisible(false);
    setBotVisible(false);
    setRestrictedVisible(false);
    setCssVisible(false);
  };
  const publishCode = () => {
    setPropertyVisible(false);
    setApperanceVisible(false);
    setCalendarVisible(false);
    setNudgesVisible(false);
    setUrlNudgesVisible(false);
    setPositionVisible(false);
    setLanguageVisible(false);
    setPublishVisible(true);
    setExternalLinkVisible(false);
    setLocationVisible(false);
    setServiceAddonVisible(false);
    setFontsVisible(false);
    setBotVisible(false);
    setRestrictedVisible(false);
    setCssVisible(false);
  };
  const setPosition = () => {
    setPropertyVisible(false);
    setApperanceVisible(false);
    setCalendarVisible(false);
    setNudgesVisible(false);
    setUrlNudgesVisible(false);
    setPositionVisible(true);
    setLanguageVisible(false);
    setPublishVisible(false);
    setExternalLinkVisible(false);
    setLocationVisible(false);
    setServiceAddonVisible(false);
    setFontsVisible(false);
    setBotVisible(false);
    setRestrictedVisible(false);
    setCssVisible(false);
  };
  const setLanguage = () => {
    setPropertyVisible(false);
    setApperanceVisible(false);
    setCalendarVisible(false);
    setNudgesVisible(false);
    setUrlNudgesVisible(false);
    setPositionVisible(false);
    setLanguageVisible(true);
    setPublishVisible(false);
    setExternalLinkVisible(false);
    setLocationVisible(false);
    setServiceAddonVisible(false);
    setFontsVisible(false);
    setBotVisible(false);
    setRestrictedVisible(false);
    setCssVisible(false);
  };
  const serviceAddons = () => {
    setPropertyVisible(false);
    setApperanceVisible(false);
    setCalendarVisible(false);
    setNudgesVisible(false);
    setUrlNudgesVisible(false);
    setPositionVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
    setExternalLinkVisible(false);
    setLocationVisible(false);
    setServiceAddonVisible(true);
    setFontsVisible(false);
    setBotVisible(false);
    setRestrictedVisible(false);
    setCssVisible(false);
  }
  const setFonts = () => {
    setPropertyVisible(false);
    setApperanceVisible(false);
    setCalendarVisible(false);
    setNudgesVisible(false);
    setUrlNudgesVisible(false);
    setPositionVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
    setExternalLinkVisible(false);
    setLocationVisible(false);
    setServiceAddonVisible(false);
    setFontsVisible(true);
    setBotVisible(false);
    setRestrictedVisible(false);
    setCssVisible(false);
  };
  const setLocation = () => {
    setPropertyVisible(false);
    setApperanceVisible(false);
    setCalendarVisible(false);
    setNudgesVisible(false);
    setUrlNudgesVisible(false);
    setPositionVisible(false);
    setFontsVisible(false);
    setPublishVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(false);
    setLocationVisible(true);
    setExternalLinkVisible(false);
    setLanguageVisible(false);
    setRestrictedVisible(false);
    setCssVisible(false);
  };
  const ExternalLink = () => {
    setPropertyVisible(false);
    setApperanceVisible(false);
    setCalendarVisible(false);
    setNudgesVisible(false);
    setUrlNudgesVisible(false);
    setPositionVisible(false);
    setFontsVisible(false);
    setPublishVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(false);
    setLocationVisible(false);
    setExternalLinkVisible(true);
    setLanguageVisible(false);
    setRestrictedVisible(false);
    setCssVisible(false);
  };
  const setBot = () => {
    setPropertyVisible(false);
    setApperanceVisible(false);
    setCalendarVisible(false);
    setNudgesVisible(false);
    setUrlNudgesVisible(false);
    setPositionVisible(false);
    setFontsVisible(false);
    setPublishVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(true);
    setLocationVisible(false);
    setExternalLinkVisible(false);
    setLanguageVisible(false);
    setRestrictedVisible(false);
    setCssVisible(false);
  };
  const setRestricted = () => {
    setPropertyVisible(false);
    setApperanceVisible(false);
    setCalendarVisible(false);
    setNudgesVisible(false);
    setUrlNudgesVisible(false);
    setFontsVisible(false);
    setPublishVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(false);
    setLocationVisible(false);
    setExternalLinkVisible(false);
    setLanguageVisible(false);
    setRestrictedVisible(true);
    setCssVisible(false);
  };
  const setCss = () => {
    setPropertyVisible(false);
    setApperanceVisible(false);
    setCalendarVisible(false);
    setNudgesVisible(false);
    setUrlNudgesVisible(false);
    setFontsVisible(false);
    setPublishVisible(false);
    setServiceAddonVisible(false);
    setBotVisible(false);
    setLocationVisible(false);
    setExternalLinkVisible(false);
    setLanguageVisible(false);
    setRestrictedVisible(false);
    setCssVisible(true);
  };
  useEffect(() => {
    if (serviceProvider) {
      fetchServiceRequest(serviceProvider);
    }
  }, [serviceProvider]);
  console.log('000', featuresUrl)
  useEffect(() => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setPropertyData(res.data);
      })
    AxiosAPI({
      method: 'get',
      url: `${API_HelpCenter_Integration}/${integrationId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        if (res.data.channel === "HelpCenter") {
          setIntegration(res.data);
        }
        else {
          setIsPageError(true);
        }
      })
      .catch((err) => console.log('err', err));
  }, [integrationId]);

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    }).then((res) => {
      setAllProperties(res.data);
    });
  }, []);
  const LoadIntegration = () => {
    AxiosAPI({
      method: 'get',
      url: `${API_HelpCenter_Integration}/${integrationId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        if (res.data.channel === "HelpCenter") {
          setIntegration(res.data);
        }
        else {
          setIsPageError(true);
        }
      })
  };

  const saveIntegration = (data) => {
    const { list, name, botSetting } = data;
    if (botSetting) {
      updateModel.botSettings = botSetting;
    }
    if (list) {
      updateModel.properties = list;
    }
    if (name) {
      updateModel.name = name;
    }

    console.log('update', updateModel);

    AxiosAPI({
      method: 'put',
      url: `${API_HelpCenter_Integration}/${integration.id}?group_id=${getGroupID()}`,
      data: updateModel,
    })
      .catch((err) => console.error(err))
      .then((res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          NotificationManager.success(
            "",
            "integration updated.",
            3000,
            null,
            null,
            "success"
          )
          setTimeout(() => {
            LoadIntegration();
          }, 500);
        }
      });

  };
  const RedirectToDemo = () => {
    var url = `${preview_demo}?gid=${getGroupID()}&iid=${integrationId}`;
    window.open(url, '_blank');
  };

  const modelNudges = integration
    ? integration.channelDetails.initiationRuleset[0].nudges.map((nudge) => {
      if (nudge.eyeCatcher && nudge.greeting) {
        return {
          eyeCatcher: {
            code: nudge.eyeCatcher.query.code,
            filterTags: null,
          },
          greeting: {
            code: nudge.greeting.query.code,
            filterTags: null,
          },
          delayInMilliseconds: nudge.delayInMilliseconds,
          delayInMillisecondsInMobile: nudge.delayInMillisecondsInMobile,
          disabledInDesktop: nudge.disabledInDesktop,
          disabledInMobile: nudge.disabledInMobile,
          buttons: nudge.buttons,
        };
      }
    })
    : null;
  const modelUrlBasedNudges = integration
    ? integration.channelDetails.initiationRuleset[0].urlBasedNudges.map((nudge) => {
      if (nudge.eyeCatcher && nudge.greeting) {
        return {
          eyeCatcher: {
            code: nudge.eyeCatcher.query.code,
            filterTags: null,
          },
          greeting: {
            code: nudge.greeting.query.code,
            filterTags: null,
          },
          delayInMilliseconds: nudge.delayInMilliseconds,
          delayInMillisecondsInMobile: nudge.delayInMillisecondsInMobile,
          disabledInDesktop: nudge.disabledInDesktop,
          disabledInMobile: nudge.disabledInMobile,
          buttons: nudge.buttons,
          otherLanguages: nudge.otherLanguages,
          displayOrder: nudge.displayOrder,
          pageURL: nudge.pageURL,
          id: nudge.id
        };
      }
    })
    : null;

  let updateModel = integration
    ? {
      name: integration.name,
      level: integration.level,
      properties: [...integration.properties],
      sessionTimeoutInSeconds: integration.sessionTimeoutInSeconds,
      baseUrl: integration.channelDetails.baseUrl,
      homePageRoute: integration.channelDetails.homePageRoute,
      defaultLanguage: 'en-US',
      defaultRuleDescription: 'Default',
      defaultRuleNudges: [...modelNudges],
      defaultRuleUrlBasedNudges: [...modelUrlBasedNudges],
      botSettings: { ...integration.botSettings },
      menuEnabled: integration.channelDetails.menuEnabled,
      persistentMenu: integration.channelDetails.persistentMenu,
      liveChatSetting: integration.liveChat,
      engagementRules: [...integration.engagementRules],
      ruleDisabled: integration.ruleDisabled
    }
    : null;

  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This integration will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    <IntlMessages id='dashboards.delete' />
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    <IntlMessages id='pages.cancel' />
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  /** FIXME: */
  const handleDelete = () => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${integrationId}/?group_id=${getGroupID()}`,
    })
      .then((res) => console.log('res', res))
      .then(
        setTimeout(() => {
          history.push('/app/pages/integration/channels');
        }, 300)
      );
  };

  return (
    <Fragment>
      {integration ? (
        <Fragment>
          <Row>
            <Colxx md="12" sm="12" lg="12" xxs="12">
              <NavLink to={{ pathname: '/app/pages/integration/channels' }}>
                <h1 className="iconsminds-back" />
              </NavLink>
            </Colxx>
          </Row>
          <Row>
            <Colxx xxs="12" md="6" className="mb-4">
              <Card>
                <CardBody>
                  <div
                    className={`mb-3 integration ${propertyVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-hotel`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => property()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id='integration.select_properties' />
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id='integration.select_properties_enabled' />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  {/* <div
                    className={`mb-3 integration ${serviceAddonVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-basket-coins`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => serviceAddons()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id='integration.services_addons' />
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id='integration.services_visible' />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div> */}
                  <div
                    className={`mb-3 integration ${apperanceVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faPalette} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => appearance()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id='integration.appearance' />
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id='integration.appearance_customize' />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${calendarVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faCalendarAlt} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => calendar()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id='integration.booking_calendar' />
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id='integration.booking_calendar_style' />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${(nudgesVisible || urlnudgesVisible) ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faHandSpock} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => nudges()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id='integration.nudges' />
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id='integration.nudges_setup' />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${positionVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faLocationArrow} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setPosition()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id='integration.position' />
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id='integration.position_control' />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>

                  <div
                    className={`mb-3 integration ${fontsVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faFont} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setFonts()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id='integration.custom_fonts' />
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id='integration.custom_fonts_upload' />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div className={`mb-3 integration ${cssVisible ? 'integration--active' : ''}`}>
                    <div className="glyph">
                      <FontAwesomeIcon icon={faFileCode} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setCss()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id='integration.custom_css' />
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id='integration.custom_css_usage' />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  {/* <div className={`mb-3 integration ${locationVisible ? 'integration--active' : ''}`}>
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-location-2`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setLocation()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id='integration.location' />
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id='integration.location_embed' />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div> */}
                  <div className={`mb-3 integration ${externalLinkVisible ? 'integration--active' : ''}`}>
                    <div className="glyph">
                      <FontAwesomeIcon icon={faExternalLinkAlt} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => ExternalLink()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id='integration.external_links' />
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id='integration.external_links_add' />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${languageVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faLanguage} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setLanguage()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id='integration.language' />
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id='integration.widget_languages' />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min  iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>

                  <div
                    className={`mb-3 integration ${botVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faRobot} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setBot()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id='integration.chatbot_contact' />
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id='integration.chatbot_enable' />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div className={`mb-3 integration ${restrictedVisible ? 'integration--active' : ''}`}>
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-security-settings`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setRestricted()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id='integration.chatbot_security' />
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id='integration.chatbot_trusted_pages' />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${publishVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon iconsminds-monitor---tablet`}
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => publishCode()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id='integration.chatbot_publish' />
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id='integration.chatbot_install' />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div>
                    <Button
                      color="dark"
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={RedirectToDemo}
                    >
                      Preview
                    </Button>

                    <Separator />
                  </div>
                  <div>
                    <Button
                      color="dark"
                      outline
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={toggle}
                    >
                      Archive
                    </Button>

                    <Separator />
                  </div>
                </CardBody>
              </Card>
            </Colxx>
            <Colxx xxs="12" md="6" className="mb-4">
              {propertyVisible && (
                <Fragment>
                  <HelpCenterIntegrationInfo
                    integration={integration}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/properties.png" /> */}
                  {/* <Example url={property_img} /> */}
                </Fragment>
              )}
              {/* {serviceAddonVisible && (
                <Fragment>
                  <HelpCenterServiceAddons
                    botSettings={integration.botSettings}
                    integrationProperties={integration.properties}
                    saveIntegration={saveIntegration}
                  />
                 
            </Fragment>
              )} */}
              {apperanceVisible && (
                <Fragment>
                  <HelpCenterDigitalAssistant
                    locale={locale}
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" /> */}
                  <Example url={appearance_img} />
                </Fragment>
              )}
              {calendarVisible && (
                <Fragment>
                  <CalendarIntegration
                    locale={locale}
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" /> */}

                </Fragment>
              )}
              {(nudgesVisible || urlnudgesVisible) && (
                <Fragment>
                  <NudgesSetting
                    integration={integration}
                    nudges={
                      integration.channelDetails.initiationRuleset[0].nudges
                    }
                    integrationId={integration.id}
                    locale={locale}
                  />
                  <UrlNudgesSetting
                    integration={integration}
                    nudges={
                      integration.channelDetails.initiationRuleset[0].urlBasedNudges
                    }
                    integrationId={integration.id}
                    locale={locale}
                  />
                  <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/nudges.png" />
                </Fragment>
              )}
              {fontsVisible && (
                <Fragment>
                  <HelpCenterCustomFonts
                    botSettings={integration.botSettings}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                  />
                  {/* <Example url={digital_guide_book} height={"40rem"} /> */}
                </Fragment>
              )}
              {cssVisible && (
                <Fragment>
                  <CustomCss
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                  ></CustomCss>
                </Fragment>
              )}
              {publishVisible && <HelpCenterCodeSnippet integration={integration} propertyId={propertyId} saveIntegration={saveIntegration} service={featuresUrl} />}
              {positionVisible && (
                <Fragment>
                  <BubblePosition
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                  />
                  <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/position.png" />
                </Fragment>
              )}
              {botVisible &&
                <Fragment>
                  <HelpCenterChatBot
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                    locale={locale}
                  />
                  <Example url={digital_guide_book} height={"40rem"} />
                </Fragment>
              }
              {/* {locationVisible && (
                <Fragment>
                  <HelpCenterLocation
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                  ></HelpCenterLocation>
                  {/* <Example url={digital_guide_book} height={"40rem"} /> 
            </Fragment>
              )} */}
              {languageVisible && (
                <Fragment>
                  <MultliLanguages
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                    isHelpcenter={true}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/languages.png" /> */}
                  <Example url={language_img} />
                </Fragment>
              )}

              {externalLinkVisible && (
                <Fragment>
                  <HelpCenterExternalLink
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                  ></HelpCenterExternalLink>
                  {/* <Example url={digital_guide_book} height={"40rem"} /> */}
                  <Example url={external_link_img} />
                </Fragment>
              )}
              {restrictedVisible && (
                <Fragment>
                  <MessengerRestricted
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                  ></MessengerRestricted>
                  {/* <Example url={digital_guide_book} height={"40rem"} /> */}
                </Fragment>
              )}
            </Colxx>
          </Row>
        </Fragment>
      ) : null
      }
      {generateDeleteButton()}
      {
        isPageError &&
        <ErrorPopup visible={isPageError} tabname="channels"></ErrorPopup>
      }
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </Fragment >
  );
}
const mapStateToProps = ({ settings, service }) => {
  const { propertyId, locale, serviceProvider } = settings;
  const { featuresUrl } = service;
  return {
    propertyId,
    locale,
    serviceProvider,
    featuresUrl,
  };
};
const mapDispatchToProps = {
  fetchServiceRequest,
};
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(HelpCenterIntegrationList));
